export const enum ApiV2Annotations {
    Color = 'color',
    BackgroundColor = 'background-color',
}
